import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { useParams, useNavigate } from "react-router-dom";
import { AiFillEye, AiFillEdit } from "react-icons/ai";
import api from "../services/api";
import Swal from "sweetalert2";
import RenderField from "./dynamicsFields/RenderField.js";
import "../css/Seguimiento.css";

// Opciones para selects y géneros fijos (igual que en Seguimiento.js)
const opcionesSexo = [
  { value: 'Masculino', label: 'Masculino' },
  { value: 'Femenino', label: 'Femenino' },
  { value: 'Otro', label: 'Otro' }
];
const generosFijos = [
  'Desconocido',
  'Mujer cis',
  'Mujer trans',
  'Varón cis',
  'Varón trans',
  'Otro'
];


export default function ControlDeSeguimiento() {
  const { idPersona } = useParams();
  const navigate = useNavigate();

  // Estado de la persona (debe estar antes de cualquier uso de 'contacto')
  const [contacto, setContacto] = useState({
    nombre: "Cargando...",
    dni: "",
    edad: "",
    sexo: "",
    genero: "",
    relacion: "",
    conviviente: "",
    comorbilidad: "",
    idCaso: null,
    atributos: "",
    idPatologia: null
  });

  // --- Estados y opciones para el modal de editar cabecera ---
  const [modalEditarCabecera, setModalEditarCabecera] = useState(false);
  const [datosCabeceraEdicion, setDatosCabeceraEdicion] = useState({
    edad: '',
    sexo: '',
    genero: '',
    conviviente: false
  });
  const [generosDisponibles, setGenerosDisponibles] = useState(generosFijos);
  const [idRelacionPrincipal, setIdRelacionPrincipal] = useState(null);
  // Relación con el caso (editable)
  const [tiposRelacion, setTiposRelacion] = useState([]);
  const [idTipoRelacionEdicion, setIdTipoRelacionEdicion] = useState("");

  // ...existing code...

  // Sugerencia dinámica de géneros (igual que en Seguimiento.js)
  useEffect(() => {
    const fetchGeneros = async () => {
      try {
        if (!contacto) return;
        const response = await api.get(`casos/${contacto.id}`);
        const generosApi = Array.from(new Set(
          (response.data?.casos || [])
            .map(c => c.Genero)
            .filter(Boolean)
        ));
        const todos = Array.from(new Set([...generosFijos, ...generosApi]));
        setGenerosDisponibles(todos);
      } catch (error) {
        setGenerosDisponibles(generosFijos);
      }
    };
    fetchGeneros();
  }, [contacto]);

  // Abrir modal y precargar datos actuales

  const abrirModalEditarCabecera = async () => {
    setDatosCabeceraEdicion({
      edad: contacto?.edad || '',
      sexo: contacto?.sexo || '',
      genero: contacto?.genero || '',
      conviviente: contacto?.conviviente === 'Sí' || contacto?.conviviente === true
    });
    // Obtener tipos de relación
    try {
      const resp = await api.get('tiposRelacion');
      setTiposRelacion(Array.isArray(resp.data) ? resp.data : []);
      // Buscar el idTipoRelacion actual (si existe en la relación principal)
      if (idRelacionPrincipal) {
        // Buscar la relación principal para obtener el idTipoRelacion
        const relResp = await api.get(`relaciones/${idPersona}`);
        if (Array.isArray(relResp.data) && relResp.data.length > 0) {
          setIdTipoRelacionEdicion(relResp.data[0].idTipoRelacion || "");
        } else {
          setIdTipoRelacionEdicion("");
        }
      } else {
        setIdTipoRelacionEdicion("");
      }
    } catch (e) {
      setTiposRelacion([]);
      setIdTipoRelacionEdicion("");
    }
    setModalEditarCabecera(true);
  };

  // Manejar cambios en los campos del modal
  const handleCambioCabecera = (campo, valor) => {
    setDatosCabeceraEdicion(prev => ({ ...prev, [campo]: valor }));
  };

  // Guardar cambios de cabecera (PATCH a persona y a relaciones)
  const guardarCabecera = async () => {
    try {
      // Enviar TODOS los campos requeridos por el backend
      const payload = {
        IdTipoDocumento: contacto?.IdTipoDocumento ?? 1,
        IdPais: contacto?.IdPais ?? 1,
        Email: contacto?.Email ?? '',
        Nombre: contacto?.nombre ?? '',
        Apellido: contacto?.apellido ?? '',
        Edad: datosCabeceraEdicion.edad !== '' ? datosCabeceraEdicion.edad : contacto?.edad ?? '',
        Sexo: datosCabeceraEdicion.sexo !== '' ? datosCabeceraEdicion.sexo : contacto?.sexo ?? '',
        NroDocumento: contacto?.dni ?? '',
        Genero: datosCabeceraEdicion.genero !== '' ? datosCabeceraEdicion.genero : contacto?.genero ?? ''
      };
      await api.patch(`personas/${idPersona}`, payload);
      // PATCH conviviente si hay idRelacionPrincipal
      if (idRelacionPrincipal !== null && typeof datosCabeceraEdicion.conviviente !== 'undefined') {
        await api.patch(`relaciones/${idRelacionPrincipal}/conviviente`, {
          conviviente: datosCabeceraEdicion.conviviente === true
        });
      }
      // PATCH tipo de relación si hay idRelacionPrincipal y el valor cambió
      let nuevoNombreRelacion = null;
      if (
        idRelacionPrincipal !== null &&
        idTipoRelacionEdicion &&
        tiposRelacion.length > 0
      ) {
        // Buscar el valor actual en la relación principal
        const relResp = await api.get(`relaciones/${idPersona}`);
        const actual = (Array.isArray(relResp.data) && relResp.data.length > 0) ? relResp.data[0].idTipoRelacion : null;
        if (actual !== idTipoRelacionEdicion) {
          await api.patch(`relaciones/${idRelacionPrincipal}/tipo`, {
            idTipoRelacion: idTipoRelacionEdicion
          });
        }
        // Buscar el nombre del tipo de relación seleccionado
        const tipoSel = tiposRelacion.find(t => String(t.idTipoRelacion) === String(idTipoRelacionEdicion));
        if (tipoSel) {
          nuevoNombreRelacion = tipoSel.nombre;
        }
      }
      setContacto(prev => ({
        ...prev,
        ...datosCabeceraEdicion,
        conviviente: datosCabeceraEdicion.conviviente ? 'Sí' : 'No',
        relacion: nuevoNombreRelacion !== null ? nuevoNombreRelacion : prev.relacion
      }));
      setRelacionCaso(nuevoNombreRelacion !== null ? nuevoNombreRelacion : relacionCaso);
      setModalEditarCabecera(false);
      Swal.fire({ icon: 'success', title: 'Cabecera actualizada', timer: 1200, showConfirmButton: false });
    } catch (err) {
      console.error('Error actualizando cabecera:', err);
      Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo actualizar la cabecera' });
    }
  };

  const [comorbilidades, setComorbilidades] = useState([]);
  const [relacionCaso, setRelacionCaso] = useState(""); // estado para relación con el caso
  const [contactosCaso, setContactosCaso] = useState([]);
  const [esCaso, setEsCaso] = useState(false);
  // Estados para modales de edición
  const [modalComorbilidades, setModalComorbilidades] = useState(false);
  const [modalAtributos, setModalAtributos] = useState(false);
  const [todasComorbilidades, setTodasComorbilidades] = useState([]);
  const [todosAtributos, setTodosAtributos] = useState([]);
  const [comorbilidadesSeleccionadas, setComorbilidadesSeleccionadas] = useState([]);
  const [atributosSeleccionados, setAtributosSeleccionados] = useState([]);

  // Función para obtener comorbilidades
const obtenerComorbilidades = async (personaId, patologiaId) => {
  if (!patologiaId) return; // si no hay patología, no hacemos la llamada

  try {
    const response = await api.get(`comorbilidadesxpersonaxpatologia/${personaId}/${patologiaId}`);

    if (response.data && Array.isArray(response.data)) {
      const nombres = response.data
        .map(c => c.NombreComorbilidad)  // según el formato que viene del backend
        .filter(Boolean);

      setComorbilidades(nombres);
    } else {
      setComorbilidades([]);
    }
  } catch (err) {
    console.error("Error obteniendo comorbilidades:", err);
    setComorbilidades([]);
  }
};

  const obtenerAtributos = async (personaId, patologiaId) => {
  try {
    const resp = await api.get(
      `atributosxpersonaxpatologia/${personaId}/${patologiaId}`
    );

    if (Array.isArray(resp.data) && resp.data.length > 0) {
      // Extraer los nombres de los atributos
      const nombres = resp.data
        .map(a => a.Atributo?.Nombre)
        .filter(Boolean);

      setContacto(prev => ({
        ...prev,
        atributos: nombres.join(" - ")
      }));
    } else {
      setContacto(prev => ({ ...prev, atributos: "" }));
    }
  } catch (err) {
    console.error("Error obteniendo atributos:", err);
    setContacto(prev => ({ ...prev, atributos: "" }));
  }
};
  // Función para obtener relación con el caso
  const obtenerRelacionCaso = async (personaId, esCasoRegistrado = false) => {
    try {
      const response = await api.get(`relaciones/${personaId}`);
      const contactosResp = await api.get(`contactos/${personaId}`);
      const contactosDirectos = Array.isArray(contactosResp.data?.contactos)
        ? contactosResp.data.contactos
        : [];

      setContactosCaso(contactosDirectos);
      setEsCaso(esCasoRegistrado || contactosDirectos.length > 0);

      if (contactosDirectos.length > 0) {
        setRelacionCaso(`Caso con ${contactosDirectos.length} contacto(s) registrado(s)`);
        setContacto(prev => ({
          ...prev,
          conviviente: "No aplica"
        }));
        return;
      }

      if (esCasoRegistrado) {
        setRelacionCaso("Caso sin contactos registrados");
        setContacto(prev => ({
          ...prev,
          conviviente: "No aplica"
        }));
        return;
      }

      if (response.data && Array.isArray(response.data) && response.data.length > 0) {
        const relacion = response.data[0]; // primera relación
        const nombreRelacionado = relacion.personaRelacionada
          ? `${relacion.personaRelacionada.nombre} ${relacion.personaRelacionada.apellido}`.trim()
          : "Persona desconocida";

        setRelacionCaso(`${relacion.tipoRelacion} del caso ${nombreRelacionado}`);
        
        // Actualizar el estado de conviviente
        setContacto(prev => ({
          ...prev,
          conviviente: relacion.conviviente ? "Sí" : "No"
        }));
      } else {
        setRelacionCaso("Sin relación registrada");
      }
    } catch (err) {
      console.error("Error obteniendo relación con el caso:", err);
      setContactosCaso([]);
      setEsCaso(esCasoRegistrado);
      setRelacionCaso(esCasoRegistrado ? "Caso sin contactos registrados" : "Sin relación registrada");
    }
  };

  // Funciones para el modal de comorbilidades
  const abrirModalComorbilidades = async () => {
    try {
      const idPatologia = contacto?.idPatologia;
      if (!idPatologia) {
        Swal.fire({ icon: "error", title: "Error", text: "No se encontró la patología asociada" });
        return;
      }
      
      // Obtener todas las comorbilidades disponibles para la patología
      const resp = await api.get(`comorbilidades/${idPatologia}`);
      setTodasComorbilidades(resp.data.filter(c => c.estado === 1));
      
      // Obtener las comorbilidades actuales de la persona
      const respActuales = await api.get(`comorbilidadesxpersonaxpatologia/${idPersona}/${idPatologia}`);
      const idsActuales = respActuales.data.map(c => c.IdComorbilidad);
      setComorbilidadesSeleccionadas(idsActuales);
      
      setModalComorbilidades(true);
    } catch (error) {
      console.error("Error cargando comorbilidades:", error);
      Swal.fire({ icon: "error", title: "Error", text: "No se pudieron cargar las comorbilidades" });
    }
  };

  const guardarComorbilidades = async () => {
    try {
      const idPatologia = contacto?.idPatologia;
      if (!idPatologia) {
        Swal.fire({ icon: "error", title: "Error", text: "No se encontró la patología asociada" });
        return;
      }
      
      // Enviar las comorbilidades seleccionadas (el backend debe manejar la lógica de reemplazo)
      await api.post('comorbilidadesxpersonaxpatologia', {
        IdPersona: parseInt(idPersona),
        IdPatologia: idPatologia,
        comorbilidades: comorbilidadesSeleccionadas
      });
      
      // Actualizar la lista de comorbilidades en la UI
      await obtenerComorbilidades(idPersona, idPatologia);
      
      setModalComorbilidades(false);
      Swal.fire({ icon: "success", title: "Guardado", text: "Comorbilidades actualizadas correctamente", timer: 1500, showConfirmButton: false });
    } catch (error) {
      console.error("Error guardando comorbilidades:", error);
      Swal.fire({ icon: "error", title: "Error", text: "No se pudieron guardar las comorbilidades" });
    }
  };

  const toggleComorbilidad = (idComorbilidad) => {
    setComorbilidadesSeleccionadas(prev => {
      if (prev.includes(idComorbilidad)) {
        return prev.filter(id => id !== idComorbilidad);
      } else {
        return [...prev, idComorbilidad];
      }
    });
  };

  // Funciones para el modal de atributos
  const abrirModalAtributos = async () => {
    try {
      const idPatologia = contacto?.idPatologia;
      if (!idPatologia) {
        Swal.fire({ icon: "error", title: "Error", text: "No se encontró la patología asociada" });
        return;
      }
      
      // Obtener todos los atributos disponibles para la patología
      const resp = await api.get(`atributosPorPatologia/${idPatologia}`);
      console.log('Atributos recibidos del backend:', resp.data);
      setTodosAtributos(resp.data.filter(a => a.estado === 1));
      
      // Obtener los atributos actuales de la persona
      const respActuales = await api.get(`atributosxpersonaxpatologia/${idPersona}/${idPatologia}`);
      console.log('Atributos actuales de la persona:', respActuales.data);
      const idsActuales = respActuales.data.map(a => a.IdAtributo);
      setAtributosSeleccionados(idsActuales);
      
      setModalAtributos(true);
    } catch (error) {
      console.error("Error cargando atributos:", error);
      Swal.fire({ icon: "error", title: "Error", text: "No se pudieron cargar los atributos" });
    }
  };

  const guardarAtributos = async () => {
    try {
      const idPatologia = contacto?.idPatologia;
      if (!idPatologia) {
        Swal.fire({ icon: "error", title: "Error", text: "No se encontró la patología asociada" });
        return;
      }
      
      // Enviar los atributos seleccionados (el backend debe manejar la lógica de reemplazo)
      await api.post('atributosxpersonaxpatologia', {
        IdPersona: parseInt(idPersona),
        IdPatologia: idPatologia,
        atributos: atributosSeleccionados
      });
      
      // Actualizar la lista de atributos en la UI
      await obtenerAtributos(idPersona, idPatologia);
      
      setModalAtributos(false);
      Swal.fire({ icon: "success", title: "Guardado", text: "Atributos actualizados correctamente", timer: 1500, showConfirmButton: false });
    } catch (error) {
      console.error("Error guardando atributos:", error);
      Swal.fire({ icon: "error", title: "Error", text: "No se pudieron guardar los atributos" });
    }
  };

  const toggleAtributo = (idAtributo) => {
    setAtributosSeleccionados(prev => {
      if (prev.includes(idAtributo)) {
        return prev.filter(id => id !== idAtributo);
      } else {
        return [...prev, idAtributo];
      }
    });
  };

  // Funciones para editar control
  const abrirModalEditar = async (control) => {
    console.log('Control a editar:', control);
    
    try {
      const idPatologia = contacto?.idPatologia;
      if (!idPatologia) {
        Swal.fire({ icon: "error", title: "Error", text: "No se encontró la patología asociada" });
        return;
      }

      if (!control.id) {
        Swal.fire({ icon: "error", title: "Error", text: "ID de control no válido" });
        return;
      }

      // Obtener todos los controles del seguimiento y filtrar por idControl
      const respControl = await api.get(`controles/${control._idSeguimiento}`);
      const controlRaw = (respControl.data || []).find(c => c.idControl === control.id);

      if (!controlRaw) {
        Swal.fire({ icon: "error", title: "Error", text: "No se encontró el control" });
        return;
      }

      const controlOriginal = {
        ...controlRaw,
        json_datos: typeof controlRaw.json_datos === 'string'
          ? (() => { try { return JSON.parse(controlRaw.json_datos); } catch { return {}; } })()
          : (controlRaw.json_datos || {})
      };

      // Cargar listas de síntomas, vacunas, medicaciones y estudios
      const [sintomasResp, vacunasResp, medicacionesResp, estudiosResp] = await Promise.all([
        api.get(`sintomasporpatologia/${idPatologia}`),
        api.get(`vacunas-por-patologia`),
        api.get(`medicaciones-por-patologia`),
        api.get(`estudios-patologia/${idPatologia}`)
      ]);

      // Procesar síntomas
      const sintomas = (sintomasResp.data || []).map(s => ({
        ...s,
        IdSintoma: s.IdSintomaPorPatologia,
        json_definicion: typeof s.json_definicion === 'string'
          ? JSON.parse(s.json_definicion)
          : (s.json_definicion || { tipo: 'texto' })
      }));
      setListaSintomas(sintomas);

      // Procesar vacunas
      const vacunasFiltradas = (vacunasResp.data || [])
        .filter(v => v.IdPatologia === idPatologia && Number(v.estado) === 1);
      const vacunasConTipo = vacunasFiltradas.map(v => ({
        IdSintoma: v.IdVacunacionPorPatologia,
        Nombre: v.NombreVacuna || `Vacuna ${v.IdVacunacionPorPatologia}`,
        json_definicion: typeof v.json_definicion === 'string'
          ? JSON.parse(v.json_definicion)
          : (v.json_definicion || { tipo: 'booleano' })
      }));
      setListaVacunas(vacunasConTipo);

      // Procesar medicaciones
      const medicacionesFiltradas = (medicacionesResp.data || [])
        .filter(m => m.IdPatologia === idPatologia && Number(m.estado) === 1);
      const medicacionesConTipo = medicacionesFiltradas.map(m => ({
        IdSintoma: m.IdMedicacionPorPatologia,
        Nombre: m.NombreMedicacion || `Medicación ${m.IdMedicacionPorPatologia}`,
        json_definicion: typeof m.json_definicion === 'string'
          ? JSON.parse(m.json_definicion)
          : (m.json_definicion || { tipo: 'booleano' })
      }));
      setListaMedicaciones(medicacionesConTipo);

      // Procesar estudios
      const estudiosConTipo = (estudiosResp.data || []).map(e => ({
        IdSintoma: e.IdEstudio,
        Nombre: e.Nombre || `Estudio ${e.IdEstudio}`,
        json_definicion: typeof e.json_definicion === 'string'
          ? JSON.parse(e.json_definicion)
          : (e.json_definicion || { tipo: 'booleano' })
      }));
      setListaEstudios(estudiosConTipo);

      // Cargar datos actuales del control
      const sintomasActuales = controlOriginal.json_datos?.sintomas || {};
      const vacunasActuales = controlOriginal.json_datos?.vacunas || {};
      const medicacionesActuales = controlOriginal.json_datos?.medicaciones || {};
      const estudiosActuales = controlOriginal.json_datos?.estudios || {};

      // Inicializar todos los campos dinámicos con los valores previos o vacío
      const sintomasCompletos = {};
      (sintomas || []).forEach(s => {
        if (sintomasActuales && sintomasActuales[s.IdSintoma] !== undefined) {
          sintomasCompletos[s.IdSintoma] = sintomasActuales[s.IdSintoma];
        } else {
          sintomasCompletos[s.IdSintoma] = '';
        }
      });
      (vacunasConTipo || []).forEach(v => {
        if (vacunasActuales && vacunasActuales[v.IdSintoma] !== undefined) {
          // ya tiene valor
        } else {
          vacunasActuales[v.IdSintoma] = '';
        }
      });
      (medicacionesConTipo || []).forEach(m => {
        if (medicacionesActuales && medicacionesActuales[m.IdSintoma] !== undefined) {
          // ya tiene valor
        } else {
          medicacionesActuales[m.IdSintoma] = '';
        }
      });
      (estudiosConTipo || []).forEach(e => {
        if (estudiosActuales && estudiosActuales[e.IdSintoma] !== undefined) {
          // ya tiene valor
        } else {
          estudiosActuales[e.IdSintoma] = '';
        }
      });

      

      const datosAntro = controlOriginal.json_datos?.datosAntropometricos || controlOriginal.json_datos || {};
      setDatosEdicion({
        peso: datosAntro.peso ?? '',
        talla: datosAntro.talla ?? '',
        intolerancias: datosAntro.intolerancias ?? '',
        alergias: datosAntro.alergias ?? '',
        observaciones: controlOriginal.observaciones ?? '',
        sintomas: { ...sintomasCompletos },
        vacunas: { ...vacunasActuales },
        medicaciones: { ...medicacionesActuales },
        estudios: { ...estudiosActuales }
      });

      setModalEditar(control);
    } catch (error) {
      console.error("Error abriendo modal de edición:", error);
      Swal.fire({ icon: "error", title: "Error", text: "No se pudo cargar la información para editar" });
    }
  };

  const handleCambioEdicion = (campo, valor) => {
    setDatosEdicion(prev => ({
      ...prev,
      [campo]: valor
    }));
  };

  const formatearValorActual = (val) => {
    if (val === null || val === undefined || val === '') return '—';
    if (typeof val === 'boolean') return val ? 'true' : 'false';
    if (typeof val === 'object' && !Array.isArray(val)) {
      return Object.entries(val)
        .filter(([, v]) => v !== null && v !== undefined && v !== '')
        .map(([k, v]) => `${k}: ${v}`)
        .join(', ');
    }
    if (Array.isArray(val)) return val.join(', ');
    return String(val);
  };

  const handleCambioDinamico = (tipo, id, valor) => {
    setDatosEdicion(prev => ({
      ...prev,
      [tipo]: {
        ...prev[tipo],
        [id]: valor
      }
    }));
  };

  const guardarEdicion = async () => {
    try {
      if (!modalEditar || !modalEditar.id) return;

      // Obtener todos los controles del seguimiento y filtrar por idControl
      const respControl = await api.get(`controles/${modalEditar._idSeguimiento}`);
      const controlRaw = (respControl.data || []).find(c => c.idControl === modalEditar.id);

      if (!controlRaw) {
        Swal.fire({ icon: "error", title: "Error", text: "No se encontró el control" });
        return;
      }

      const controlOriginal = {
        ...controlRaw,
        json_datos: typeof controlRaw.json_datos === 'string'
          ? (() => { try { return JSON.parse(controlRaw.json_datos); } catch { return {}; } })()
          : (controlRaw.json_datos || {})
      };

      // Actualizar todos los datos
      const json_datos_actualizado = {
        ...controlOriginal.json_datos,
        datosAntropometricos: {
          peso: datosEdicion.peso === '' ? null : datosEdicion.peso,
          talla: datosEdicion.talla === '' ? null : datosEdicion.talla,
          intolerancias: datosEdicion.intolerancias === '' ? null : datosEdicion.intolerancias,
          alergias: datosEdicion.alergias === '' ? null : datosEdicion.alergias
        },
        sintomas: datosEdicion.sintomas,
        vacunas: datosEdicion.vacunas,
        medicaciones: datosEdicion.medicaciones,
        estudios: datosEdicion.estudios
      };

      // Si vacunas es array, convertir a objeto para reglas (legacy)
      if (Array.isArray(json_datos_actualizado.vacunas)) {
        const vacunasObj = {};
        json_datos_actualizado.vacunas.forEach(id => {
          vacunasObj[id] = true;
        });
        json_datos_actualizado.vacunas = vacunasObj;
      }

      // Normalizar vacunas: asegurar que cada clave sea string y el valor sea el seleccionado (por ejemplo, 'dosis comun')
      if (json_datos_actualizado.vacunas && typeof json_datos_actualizado.vacunas === 'object') {
        const vacunasNormalizadas = {};
        Object.entries(json_datos_actualizado.vacunas).forEach(([key, val]) => {
          // Si el valor es un objeto con propiedad 'valor', usar ese valor (por si algún selector lo guarda así)
          if (val && typeof val === 'object' && 'valor' in val) {
            vacunasNormalizadas[String(key)] = val.valor;
          } else {
            vacunasNormalizadas[String(key)] = val;
          }
        });
        json_datos_actualizado.vacunas = vacunasNormalizadas;
      }

      // Enviar actualización al servidor
      const response = await api.put(`controles/${modalEditar.id}`, {
        idUsuario: controlOriginal.idUsuario,
        numeroControl: controlOriginal.numeroControl,
        fechaControl: controlOriginal.fechaControl,
        observaciones: datosEdicion.observaciones,
        json_datos: json_datos_actualizado
      });

      // 🔥 Verificar si hay reglas activadas (backend)
      if (response.data?.evaluacionReglas?.reglasActivadas?.length > 0) {
        const reglas = response.data.evaluacionReglas.reglasActivadas;
        // Crear mensaje con las reglas activadas
        let mensaje = '<div style="text-align: left;"><strong>Se activaron las siguientes reglas:</strong><br/><br/>';
        reglas.forEach((regla, index) => {
          // Mejor lógica: buscar mensaje en todos los campos posibles
          const mensajeRegla =
            regla.Json_Definicion?.mensaje ||
            regla.Json_Definicion?.Mensaje ||
            regla.Json_Definicion?.accion ||
            regla.Json_Definicion?.Accion ||
            regla.Accion ||
            regla.Mensaje ||
            regla.mensaje ||
            'Sin mensaje definido';
          mensaje += `<div style="margin-bottom: 10px; padding: 10px; background: #f8f9fa; border-left: 4px solid #ff9800; border-radius: 4px;">
            <strong>${index + 1}. ${regla.Nombre}</strong><br/>
            <span style="color: #666;">${regla.Descripcion || regla.descripcion || ''}</span><br/>
            <strong style="color: #d32f2f;">Alerta:</strong> ${mensajeRegla}
          </div>`;
        });
        mensaje += '</div>';
        await Swal.fire({
          icon: "warning",
          title: "⚠️ Alerta de Reglas",
          html: mensaje,
          width: 600,
          confirmButtonText: "Entendido",
          confirmButtonColor: "#d32f2f"
        });
      } else {
        await Swal.fire({ 
          icon: "success", 
          title: "Guardado", 
          text: "Control actualizado correctamente", 
          timer: 1500, 
          showConfirmButton: false 
        });
      }

      // --- Lógica adicional SOLO para reglas de relación con el caso (frontend) ---
      try {
        // 1. Obtener reglas desde el backend (o desde donde las tengas)
        const reglasResp = await api.get('reglas');
        const reglas = Array.isArray(reglasResp.data) ? reglasResp.data : [];
        console.log('[REGLAS] Todas las reglas obtenidas:', reglas);
        // 2. Buscar reglas de tipo 'relacion' (o la categoría/campo que corresponda)
        //    y comparar con el valor de la cabecera (relacionCaso)
        const reglasRelacion = reglas.filter(r =>
          (r.campo === 'relacion' || r.categoria === 'relacion' )
        );
        console.log('[REGLAS] Reglas de relación con el caso:', reglasRelacion);
        // 3. Normalizar el valor de la cabecera para comparar solo el tipo de relación (sin el nombre relacionado)
        //    Ejemplo: "Padre del caso Juan Perez" => "Padre"
        let valorRelacionCabecera = '';
        if (relacionCaso && typeof relacionCaso === 'string') {
          valorRelacionCabecera = relacionCaso.split(' del caso')[0].trim();
        }
        console.log('[REGLAS] Valor de relación de la cabecera:', valorRelacionCabecera);
        // 4. Buscar coincidencias
        const normalizar = v => (v || '').toString().trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        const reglasCoincidentes = reglasRelacion.filter(r => {
          // Puede ser r.valor, r.valorCondicion, etc. según tu modelo
          const valorRegla = r.valor || r.valorCondicion || r.condicion || '';
          const operador = r.operador || r.operadorCondicion || r.operadorComparacion || '';
          const valCab = normalizar(valorRelacionCabecera);
          const valRegla = normalizar(valorRegla);
          console.log('[REGLAS][DEBUG] Regla:', r);
          console.log('[REGLAS][DEBUG] valorRelacionCabecera:', valorRelacionCabecera, '| valCab:', valCab);
          console.log('[REGLAS][DEBUG] valorRegla:', valorRegla, '| valRegla:', valRegla);
          console.log('[REGLAS][DEBUG] operador:', operador);
          if (operador === 'like') {
            const resultado = valCab && valRegla && valCab.includes(valRegla);
            console.log('[REGLAS][DEBUG] LIKE resultado:', resultado);
            return resultado;
          } else {
            const resultado = valCab && valRegla && valCab === valRegla;
            console.log('[REGLAS][DEBUG] IGUAL resultado:', resultado);
            return resultado;
          }
        });
        console.log('[REGLAS] Reglas coincidentes:', reglasCoincidentes);
        if (reglasCoincidentes.length > 0) {
          // Mostrar alerta con los mensajes de las reglas coincidentes
          let mensaje = '<div style="text-align: left;"><strong>Se activaron reglas por Relación con el caso:</strong><br/><br/>';
          reglasCoincidentes.forEach((regla, index) => {
            mensaje += `<div style="margin-bottom: 10px; padding: 10px; background: #f8f9fa; border-left: 4px solid #2196f3; border-radius: 4px;">
              <strong>${index + 1}. ${regla.nombre || regla.Nombre || 'Regla'}</strong><br/>
              <span style="color: #666;">${regla.descripcion || regla.Descripcion || ''}</span><br/>
              <strong style="color: #1976d2;">Mensaje:</strong> ${regla.mensaje || regla.Mensaje || regla.accion || regla.Accion || ''}
            </div>`;
          });
          mensaje += '</div>';
          await Swal.fire({
            icon: "info",
            title: "ℹ️ Alerta de Relación con el caso",
            html: mensaje,
            width: 600,
            confirmButtonText: "Entendido",
            confirmButtonColor: "#1976d2"
          });
        }
      } catch (e) {
        // Si falla la consulta de reglas, no afecta el resto
        console.error('Error verificando reglas de relación con el caso:', e);
      }
      // --- Fin lógica adicional ---

      // Actualizar la lista de controles
      const idSeguimientoParaRecargar = modalEditar._idSeguimiento;
      if (idSeguimientoParaRecargar && contacto.idPatologia) {
        await obtenerControles(idSeguimientoParaRecargar, contacto.idPatologia);
      }

      setModalEditar(null);
    } catch (error) {
      console.error("Error guardando control:", error);
      Swal.fire({ icon: "error", title: "Error", text: "No se pudo guardar el control" });
    }
  };

  // Función para obtener controles
  const obtenerControles = async (idSeguimiento, idPatologia) => {
    try {
      const response = await api.get(`controles/${idSeguimiento}`);
      console.log('GET /controles response:', response.data);
      // Normalizar respuesta a array por compatibilidad con diferentes formas de retorno
      const dataArray = Array.isArray(response.data) ? response.data : (response.data ? [response.data] : []);
      if (dataArray && Array.isArray(dataArray)) {
        // Obtener listas de vacunas, medicaciones y estudios para mapear IDs a nombres
        console.log('idPatologia for mapping:', idPatologia);
        // Only fetch estudios if we have an idPatologia, otherwise use empty
        const fetches = [
          api.get('vacunas-por-patologia'),
          api.get('medicaciones-por-patologia')
        ];
        if (idPatologia) fetches.push(api.get(`estudios-patologia/${idPatologia}`));

        const responses = await Promise.all(fetches);
        const vacunasResp = responses[0];
        const medicacionesResp = responses[1];
        const estudiosResp = responses[2] || { data: [] };

        console.log('Respuesta vacunas:', vacunasResp.data);
        console.log('Respuesta medicaciones:', medicacionesResp.data);
        console.log('Respuesta estudios:', estudiosResp.data);

        const vacunasMap = {};
        const medicacionesMap = {};
        const estudiosMap = {};

        if (vacunasResp.data) {
          console.log('Procesando vacunas...');
          vacunasResp.data.forEach(v => {
            console.log('Vacuna item:', v);
            console.log('IdVacunacionPorPatologia:', v.IdVacunacionPorPatologia, 'IdVacunacion:', v.IdVacunacion, 'NombreVacuna:', v.NombreVacuna);
            // Mapear por IdVacunacionPorPatologia y por IdVacunacion por compatibilidad
            if (v.IdVacunacionPorPatologia != null) vacunasMap[v.IdVacunacionPorPatologia] = v.NombreVacuna || `Vacuna ${v.IdVacunacionPorPatologia}`;
            if (v.IdVacunacion != null) vacunasMap[v.IdVacunacion] = v.NombreVacuna || `Vacuna ${v.IdVacunacion}`;
            console.log('Mapa vacunas actual:', vacunasMap);
          });
        }

        if (medicacionesResp.data) {
          medicacionesResp.data.forEach(m => {
            // Mapear por ambos posibles IDs
            if (m.IdMedicacionPorPatologia != null) medicacionesMap[m.IdMedicacionPorPatologia] = m.NombreMedicacion || `Medicación ${m.IdMedicacionPorPatologia}`;
            if (m.IdMedicacion != null) medicacionesMap[m.IdMedicacion] = m.NombreMedicacion || `Medicación ${m.IdMedicacion}`;
          });
        }

        if (estudiosResp.data) {
          estudiosResp.data.forEach(e => {
            estudiosMap[e.IdEstudio] = e.Nombre;
          });
        }

        // Mapear los datos al formato de la tabla
        const controlesMapeados = dataArray.map(control => {
          const json_datos = typeof control.json_datos === 'string'
            ? (() => { try { return JSON.parse(control.json_datos); } catch { return {}; } })()
            : (control.json_datos || {});
          return ({
          id: control.idControl,
          fechaHora: control.fechaControl ? new Date(control.fechaControl).toLocaleString('es-ES') : '',
          peso: json_datos?.peso || '',
          talla: json_datos?.talla || '',
          sintomas: (() => {
            const sintomasList = json_datos?.sintomas ? Object.values(json_datos.sintomas).filter(Boolean) : [];
            const temperatura = json_datos?.contacto?.temperatura || json_datos?.temperatura;
            console.log('Control ID:', control.idControl);
            console.log('json_datos completo:', json_datos);
            console.log('Temperatura encontrada:', temperatura);
            console.log('Síntomas encontrados:', sintomasList);
            const tempText = temperatura ? `Temp: ${temperatura}°C` : '';
            console.log('Texto temperatura generado:', tempText);
            const resultado = [tempText, ...sintomasList].filter(Boolean).join(', ');
            console.log('Resultado final síntomas:', resultado);
            return resultado;
          })(),
          vacunas: (() => {
            const vacunasData = json_datos?.vacunas;
            console.log('Control ID:', control.idControl, '- vacunas payload:', vacunasData);
            console.log('Tipo de vacunasData:', typeof vacunasData, 'isArray:', Array.isArray(vacunasData));
            
            if (!vacunasData) return '';
            
            // Si es array (legacy)
            if (Array.isArray(vacunasData)) {
              const nombres = vacunasData.map(item => {
                const idCandidates = [];
                if (typeof item === 'number' || typeof item === 'string') idCandidates.push(Number(item));
                if (item && typeof item === 'object') {
                  if (item.IdVacunacionPorPatologia) idCandidates.push(Number(item.IdVacunacionPorPatologia));
                  if (item.IdVacunacion) idCandidates.push(Number(item.IdVacunacion));
                }
                const found = idCandidates.map(c => vacunasMap[c]).find(Boolean);
                return found || `ID ${idCandidates[0] ?? item}`;
              });
              return nombres.join(', ');
            }
            
            // Si es objeto parametrizado { IdVacuna: valor }
            if (typeof vacunasData === 'object') {
              const partes = Object.entries(vacunasData)
                .filter(([k, v]) => v) // Solo los que tienen valor
                .map(([key, val]) => {
                  const nombre = vacunasMap[key] || `Vacuna ${key}`;
                  if (typeof val === 'boolean') return nombre;
                  if (Array.isArray(val)) return `${nombre}: ${val.join(', ')}`;
                  return `${nombre}: ${val}`;
                });
              return partes.join(' | ');
            }
            
            return String(vacunasData);
          })(),
          estudios: (() => {
            const estudiosData = json_datos?.estudios;
            console.log('Control ID:', control.idControl, '- estudios payload:', estudiosData);
            console.log('Tipo de estudiosData:', typeof estudiosData, 'isArray:', Array.isArray(estudiosData));
            
            if (!estudiosData) return '';

            // Si vienen como array de IDs/objetos: comportamiento legacy
            if (Array.isArray(estudiosData)) {
              const nombres = estudiosData.map(item => {
                const id = typeof item === 'number' || typeof item === 'string' ? Number(item) : (item?.IdEstudio ? Number(item.IdEstudio) : null);
                const nombre = id != null ? estudiosMap[id] : null;
                return nombre || `ID ${id ?? item}`;
              });
              return nombres.join(', ');
            }

            // Si vienen como objeto parametrizado { IdEstudio: value }
            if (typeof estudiosData === 'object') {
              const partes = Object.entries(estudiosData)
                .filter(([k, v]) => v !== null && v !== undefined && v !== '' && v !== false)
                .map(([key, val]) => {
                  const nombre = estudiosMap[key] || `Estudio ${key}`;
                  let textoVal = '';
                  if (Array.isArray(val)) textoVal = val.join(', ');
                  else if (typeof val === 'object') textoVal = JSON.stringify(val);
                  else if (typeof val === 'boolean') return nombre; // Si es booleano true, solo mostrar nombre
                  else textoVal = String(val);
                  return textoVal ? `${nombre}: ${textoVal}` : nombre;
                });
              return partes.join(' | ');
            }

            return String(estudiosData);
          })(),
          medicacion: (() => {
            const medicData = json_datos?.medicaciones;
            console.log('Control ID:', control.idControl, '- medicaciones payload:', medicData);
            console.log('Tipo de medicData:', typeof medicData, 'isArray:', Array.isArray(medicData));
            
            if (!medicData) return '';

            // Legacy array of ids/objects
            if (Array.isArray(medicData)) {
              return medicData.map(item => {
                const id = typeof item === 'number' || typeof item === 'string' ? Number(item) : (item?.IdMedicacionPorPatologia ? Number(item.IdMedicacionPorPatologia) : (item?.IdMedicacion ? Number(item.IdMedicacion) : null));
                return id != null ? (medicacionesMap[id] || `ID ${id}`) : String(item);
              }).join(', ');
            }

            // Parametrized object { IdMedicacionPorPatologia: value }
            if (typeof medicData === 'object') {
              const parts = Object.entries(medicData)
                .filter(([k, v]) => v !== null && v !== undefined && v !== '' && v !== false)
                .map(([key, val]) => {
                  const nombre = medicacionesMap[key] || `Medicación ${key}`;
                  if (typeof val === 'boolean') return nombre;
                  if (Array.isArray(val)) return `${nombre}: ${val.join(', ')}`;
                  if (typeof val === 'object') return `${nombre}: ${JSON.stringify(val)}`;
                  return `${nombre}: ${val}`;
                });
              return parts.join(' | ');
            }

            return String(medicData);
          })(),
          intolerancia: json_datos?.intolerancias || '',
          alergias: json_datos?.alergias || '',
          observaciones: control.observaciones || '',
          _json_datos: json_datos,
          _idSeguimiento: control.idSeguimiento,
          _idUsuario: control.idUsuario,
          _numeroControl: control.numeroControl,
          _fechaControl: control.fechaControl
        });
        });
        setControles(controlesMapeados);
        console.log('Controles mapeados seteados:', controlesMapeados);
      } else {
        setControles([]);
      }
    } catch (err) {
      console.error("Error obteniendo controles:", err);
      setControles([]);
    }
  };



  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Actualizar comorbilidades en contacto
  useEffect(() => {
    if (comorbilidades.length > 0) {
      setContacto(prev => ({
        ...prev,
        comorbilidad: comorbilidades.join(" - "),
      }));
    }
  }, [comorbilidades]);

  // Fetch de datos principales
  useEffect(() => {
    const fetchPersona = async () => {
      try {
        setLoading(true);
        setError(null);

        const resp = await api.get(`seguimiento/persona/${idPersona}`);
        const personaData = resp.data;
        const esCasoRegistrado = Number(
          personaData.idClasificacionPersona ||
          personaData.IdClasificacionPersona ||
          personaData.clasificacionPersona
        ) === 1;

        // Guardar idPersona en localStorage para reglas
        localStorage.setItem("idPersonaSeleccionada", idPersona);

        setContacto({
          nombre: personaData.nombre || `${personaData.Nombre || ''} ${personaData.Apellido || ''}`.trim() || "Sin nombre",
          dni: personaData.dni || personaData.NroDocumento || personaData.Documento || "",
          edad: personaData.edad || personaData.Edad || "",
          sexo: personaData.sexo || personaData.Sexo || "",
          genero: personaData.genero || personaData.Genero || personaData.Sexo || "",
          relacion: personaData.relacion || personaData.RelacionCaso || personaData.Relacion || "",
          conviviente: personaData.conviviente || "No",
          comorbilidad: "",
          atributos: "",
          idCaso: personaData.IdCaso || personaData.idCaso || personaData.Caso || null,
          idPatologia: personaData.idPatologia || null
        });
        setEsCaso(esCasoRegistrado);

        await obtenerComorbilidades(idPersona);

        // Obtener atributos si hay IdPatologia
        if (personaData.idPatologia) {
           await obtenerComorbilidades(idPersona, personaData.idPatologia);
           await obtenerAtributos(idPersona, personaData.idPatologia);
        }

        // Obtener y setear idRelacionPrincipal
        try {
          const relResp = await api.get(`relaciones/${idPersona}`);
          if (Array.isArray(relResp.data) && relResp.data.length > 0) {
            setIdRelacionPrincipal(relResp.data[0].idRelaciones || relResp.data[0].IdRelaciones || relResp.data[0].id || null);
          } else {
            setIdRelacionPrincipal(null);
          }
        } catch (e) {
          setIdRelacionPrincipal(null);
        }

        await obtenerRelacionCaso(idPersona, esCasoRegistrado);

        // Obtener controles si hay idSeguimiento
        if (personaData.idSeguimiento) {
          await obtenerControles(personaData.idSeguimiento, personaData.idPatologia);
        }

        setLoading(false);

      } catch (error) {
        console.error("Error al cargar datos de la persona:", error);
        setError(error.response?.data?.message || "Error al cargar datos");
        setLoading(false);

        // Datos mock de respaldo
        setContacto({
          nombre: "Juan Pérez",
          dni: "12345678",
          edad: "35",
          sexo: "Masculino",
          genero: "Otro",
          relacion: "Colegas",
          conviviente: "No",
          comorbilidad: "Diabetes - Obesidad",
          atributos: "Diabetes - Obesidad",
          idCaso: 123,
          idPatologia: 1
        });
        setRelacionCaso("Hermano de caso #123");
        setIdRelacionPrincipal(null);
      }
    };

    fetchPersona();
  }, [idPersona]);

  // Controles médicos
  const [controles, setControles] = useState([]);
  // Columnas para DataTable
  const columnas = [
    { name: "Fecha y Hora", selector: row => row.fechaHora, sortable: true },
    { name: "Peso", selector: row => row.peso, sortable: false },
    { name: "Talla", selector: row => row.talla, sortable: false },
    { name: "🌡️ Síntomas", selector: row => row.sintomas, sortable: false },
    { name: "Vacunas", selector: row => row.vacunas, sortable: false },
    { name: "Estudios", selector: row => row.estudios, sortable: false },
    { name: "Medicación", selector: row => row.medicacion, sortable: false },
    { name: "Intolerancia", selector: row => row.intolerancia, sortable: false },
    { name: "Alergias", selector: row => row.alergias, sortable: false },
    { name: "Observaciones", selector: row => row.observaciones, sortable: false },
    {
      name: "Ver / Editar",
      cell: row => (
        <>
          <button style={styles.btnIcono} onClick={() => setModalVer(row)} title="Ver detalles"><AiFillEye /></button>
          <button style={styles.btnIcono} onClick={() => abrirModalEditar(row)} title="Editar"><AiFillEdit /></button>
        </>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true
    }
  ];

  const [otraTabla] = useState([
    { id: 1, fecha: "2024-12-01", tipo: "Control general", resultado: "Normal", profesional: "Dr. García" },
    { id: 2, fecha: "2024-11-15", tipo: "Laboratorio", resultado: "Glucosa elevada", profesional: "Dra. Martínez" },
    { id: 3, fecha: "2024-10-20", tipo: "Consulta especial", resultado: "Estable", profesional: "Dr. Rodríguez" }
  ]);

  const [modalVer, setModalVer] = useState(null);
  const [modalEditar, setModalEditar] = useState(null);
  const [datosEdicion, setDatosEdicion] = useState({
    peso: '',
    talla: '',
    intolerancias: '',
    alergias: '',
    observaciones: '',
    sintomas: {},
    vacunas: {},
    medicaciones: {},
    estudios: {}
  });
  const [listaSintomas, setListaSintomas] = useState([]);
  const [listaVacunas, setListaVacunas] = useState([]);
  const [listaMedicaciones, setListaMedicaciones] = useState([]);
  const [listaEstudios, setListaEstudios] = useState([]);
  const [modalCarrusel, setModalCarrusel] = useState(false);
  const [tablaActiva, setTablaActiva] = useState("controles");
  const [indiceCarrusel, setIndiceCarrusel] = useState(0);

  const mostrarSiguiente = () => {
    if (tablaActiva === "controles") setIndiceCarrusel((prev) => (prev + 1) % controles.length);
    else setIndiceCarrusel((prev) => (prev + 1) % otraTabla.length);
  };

  const mostrarAnterior = () => {
    if (tablaActiva === "controles") setIndiceCarrusel((prev) => (prev - 1 + controles.length) % controles.length);
    else setIndiceCarrusel((prev) => (prev - 1 + otraTabla.length) % otraTabla.length);
  };

  if (loading) {
    return (
      <div style={styles.container}>
        <div style={styles.loadingContainer}>
          <div style={styles.loadingSpinner}></div>
          <p>Cargando datos del paciente...</p>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {/* CABECERA */}
      <div style={styles.cabeceraContainer}>
                {/* BOTÓN EDITAR CABECERA alineado con 'Relación con el caso' */}
                <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', marginBottom: 8 }}>
                  <div style={{ flex: 1 }}>
                    {/* NUEVA RELACIÓN CON EL CASO */}
                    <div style={{ fontWeight: "bold", marginBottom: "5px" }}>
                      {esCaso ? "Contactos del caso" : "Relación con el caso"}: <span style={{ fontWeight: "normal" }}>{relacionCaso}</span>
                    </div>
                    {esCaso && (
                      <div style={{ fontSize: "13px", color: "#444", lineHeight: 1.5 }}>
                        {contactosCaso.length > 0
                          ? contactosCaso.map((contactoCaso) => {
                              const nombreContacto = `${contactoCaso.Nombre || ""} ${contactoCaso.Apellido || ""}`.trim() || "Sin nombre";
                              const documentoContacto = contactoCaso.NroDocumento ? `DNI ${contactoCaso.NroDocumento}` : "DNI no registrado";
                              return `${nombreContacto} (${documentoContacto})`;
                            }).join(" | ")
                          : "No registra contactos asociados"}
                      </div>
                    )}
                  </div>
                  <button
                    style={{
                      background: '#13bd95',
                      color: '#fff',
                      border: 'none',
                      borderRadius: '6px',
                      padding: '8px 16px',
                      fontWeight: 'bold',
                      fontSize: '16px',
                      boxShadow: '0 2px 6px rgba(0,0,0,0.08)',
                      cursor: 'pointer',
                      transition: 'background 0.2s',
                      marginLeft: '10px'
                    }}
                    onClick={abrirModalEditarCabecera}
                  >
                    Editar cabecera
                  </button>
                </div>
              {/* MODAL EDITAR CABECERA */}
              {modalEditarCabecera && (
                <div className="modal is-active">
                  <div className="modal-background" onClick={() => setModalEditarCabecera(false)}></div>
                  <div className="modal-card" style={{ maxWidth: "600px", maxHeight: "90vh" }}>
                    <header className="modal-card-head">
                      <p className="modal-card-title">Editar Cabecera</p>
                      <button className="delete" aria-label="close" onClick={() => setModalEditarCabecera(false)}></button>
                    </header>
                    <section className="modal-card-body" style={{ maxHeight: "calc(90vh - 150px)", overflowY: "auto" }}>
                      <div className="field">
                        <label className="label">Edad</label>
                        <div className="control">
                          <input className="input" type="number" value={datosCabeceraEdicion.edad} onChange={e => handleCambioCabecera('edad', e.target.value)} />
                        </div>
                      </div>
                      <div className="field">
                        <label className="label">Sexo</label>
                        <div className="control">
                          <select className="input" value={datosCabeceraEdicion.sexo} onChange={e => handleCambioCabecera('sexo', e.target.value)}>
                            <option value="">Seleccione...</option>
                            {opcionesSexo.map(opt => (
                              <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="field">
                        <label className="label">Género</label>
                        <div className="control">
                          <select className="input" value={datosCabeceraEdicion.genero} onChange={e => handleCambioCabecera('genero', e.target.value)}>
                            <option value="">Seleccione...</option>
                            {generosDisponibles.map(g => (
                              <option key={g} value={g}>{g}</option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="field">
                        <label className="label">Tipo de Relación con el caso</label>
                        <div className="control">
                          <select
                            className="input"
                            value={idTipoRelacionEdicion}
                            onChange={e => setIdTipoRelacionEdicion(e.target.value)}
                          >
                            <option value="">Seleccione...</option>
                            {tiposRelacion.map(tipo => (
                              <option key={tipo.idTipoRelacion} value={tipo.idTipoRelacion}>
                                {tipo.nombre}
                              </option>
                            ))}
                          </select>
                        </div>
                        {/* ...bloque de debug eliminado... */}
                      </div>
                      <div className="field">
                        <label className="label">Conviviente</label>
                        <div className="control" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <input
                            type="checkbox"
                            checked={datosCabeceraEdicion.conviviente === true}
                            onChange={e => handleCambioCabecera('conviviente', e.target.checked)}
                          />
                          <span>{datosCabeceraEdicion.conviviente ? 'Sí' : 'No'}</span>
                        </div>
                      </div>
                    </section>
                    <footer className="modal-card-foot">
                      <button className="button is-success" onClick={guardarCabecera}>Guardar Cambios</button>
                      <button className="button" onClick={() => setModalEditarCabecera(false)}>Cancelar</button>
                    </footer>
                  </div>
                </div>
              )}
        {contacto.idCaso && (
          <div style={{ fontWeight: "bold", fontSize: "17px", color: "#444", marginBottom: "5px" }}>
            Caso Nº: <span style={{ fontWeight: "normal" }}>{contacto.idCaso}</span>
          </div>
        )}

        {/* NUEVA RELACIÓN CON EL CASO */}
        {/* Eliminado: Duplicado de 'Relación con el caso' */}

        {/* SEGUIMIENTO DEL CONTACTO */}
        <div style={{ fontWeight: "bold", marginBottom: "5px" }}>
          Seguimiento del {esCaso ? "caso" : "contacto"}: <span style={{ fontWeight: "normal" }}>{contacto.nombre}</span>
        </div>

        <div style={styles.datosLinea}>
          DNI: <span style={styles.dato}>{contacto.dni}</span>
          Edad: <span style={styles.dato}>{contacto.edad}</span>
          Sexo: <span style={styles.dato}>{contacto.sexo}</span>
          Género: <span style={styles.dato}>{contacto.genero}</span>
          Conviviente: <span style={styles.dato}>{contacto.conviviente}</span>
        </div>

        <div style={{ display: "flex", alignItems: "center", marginBottom: "4px" }}>
          <div style={{ ...styles.datosLinea, marginBottom: 0, flex: 1 }}>
            Comorbilidad: <span style={styles.dato}>{comorbilidades.length > 0 ? comorbilidades.join(" - ") : "No se registran comorbilidades"}</span>
          </div>
          <button style={styles.btnCabeceraPeque} onClick={abrirModalComorbilidades}>Editar Comorbilidades</button>
        </div>

        <div style={{ display: "flex", alignItems: "center", marginBottom: "4px" }}>
          <div style={{ ...styles.datosLinea, marginBottom: 0, flex: 1 }}>
            Atributos Personales: <span style={styles.dato}>{contacto.atributos}</span>
          </div>
          <button style={styles.btnCabeceraPeque} onClick={abrirModalAtributos}>Editar Atributos</button>
        </div>
      </div>

      {/* BOTONES */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
        <div style={{ display: "flex", gap: "10px" }}>
          <button style={styles.btnVolver} onClick={() => navigate(-1)}>← Volver</button>
       
        </div>
        <button style={styles.btnNuevoControl} onClick={() => navigate(`/PrivateMainPage/Seguimiento/${idPersona}`)}>+ NUEVO CONTROL</button>
      </div>

      {/* TABLA DE CONTROLES */}
      <div style={styles.tablaContainer}>
        <div style={{ marginBottom: 8, fontSize: 13, color: '#333' }}>Controles encontrados: {controles.length}</div>
        <DataTable
          columns={columnas}
          data={controles}
          pagination
          paginationPerPage={10}
          paginationRowsPerPageOptions={[10, 20, 30]}
          highlightOnHover
          striped
          responsive
          noDataComponent="No hay controles para mostrar"
        />
      </div>

      {/* MODAL CARRUSEL */}
      {modalCarrusel && (
        <div style={styles.modalOverlay} onClick={() => setModalCarrusel(false)}>
          <div style={styles.modalCarrusel} onClick={(e) => e.stopPropagation()}>
            <h2 style={styles.modalTituloGrande}>
              {tablaActiva === "controles" ? "CONTROLES ANTERIORES - CARRUSEL" : "OTRA TABLA - CARRUSEL"}
            </h2>
            
            <div style={styles.selectorTabla}>
              <button 
                style={tablaActiva === "controles" ? styles.btnTablaActiva : styles.btnTablaInactiva}
                onClick={() => {
                  setTablaActiva("controles");
                  setIndiceCarrusel(0);
                }}
              >
                📋 Controles Médicos
              </button>
              <button 
                style={tablaActiva === "otra" ? styles.btnTablaActiva : styles.btnTablaInactiva}
                onClick={() => {
                  setTablaActiva("otra");
                  setIndiceCarrusel(0);
                }}
              >
                📊 Otra Tabla
              </button>
            </div>

            <div style={styles.carruselContainer}>
              <button style={styles.btnFlecha} onClick={mostrarAnterior}>
                ◀
              </button>
              
              <div style={styles.carruselContenido}>
                {tablaActiva === "controles" ? (
                  <div style={styles.carruselItem}>
                    <h3>Control #{indiceCarrusel + 1}</h3>
                    <div style={styles.detallesItem}>
                      <p><strong>Fecha:</strong> {controles[indiceCarrusel].fechaHora}</p>
                      <p><strong>Peso:</strong> {controles[indiceCarrusel].peso}</p>
                      <p><strong>Síntomas:</strong> {controles[indiceCarrusel].sintomas}</p>
                      <p><strong>Observaciones:</strong> {controles[indiceCarrusel].observaciones}</p>
                    </div>
                  </div>
                ) : (
                  <div style={styles.carruselItem}>
                    <h3>Registro #{indiceCarrusel + 1}</h3>
                    <div style={styles.detallesItem}>
                      <p><strong>Fecha:</strong> {otraTabla[indiceCarrusel].fecha}</p>
                      <p><strong>Tipo:</strong> {otraTabla[indiceCarrusel].tipo}</p>
                      <p><strong>Resultado:</strong> {otraTabla[indiceCarrusel].resultado}</p>
                    </div>
                  </div>
                )}
              </div>
              
              <button style={styles.btnFlecha} onClick={mostrarSiguiente}>
                ▶
              </button>
            </div>

            <div style={styles.contador}>
              {indiceCarrusel + 1} de {tablaActiva === "controles" ? controles.length : otraTabla.length}
            </div>

            <div style={styles.modalBotonesGrandes}>
              <button 
                style={styles.btnCerrarGrande}
                onClick={() => setModalCarrusel(false)}
              >
                Cerrar Carrusel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL VER DETALLES */}
      {modalVer && (
        <div style={styles.modalOverlay} onClick={() => setModalVer(null)}>
          <div className="seguimiento-card" style={{ maxWidth: "900px", maxHeight: "85vh", overflowY: "auto", margin: "auto" }} onClick={(e) => e.stopPropagation()}>
            <header className="seguimiento-header">
              <div>
                <div style={{ fontWeight: "bold", fontSize: "17px", color: "#444", marginBottom: "10px" }}>
                  Detalles del Control
                </div>
                
                <div style={{ marginBottom: "3px", lineHeight: "1.5", fontSize: "14px" }}>
                  <strong>Fecha del control:</strong> <span style={{ color: "#555", marginRight: "12px" }}>{modalVer.fechaHora}</span>
                </div>
              </div>
            </header>

            {/* Datos antropométricos */}
            <section className="seguimiento-section">
              <h3>Datos antropométricos</h3>
              <div className="seguimiento-grid-2" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "15px" }}>
                <div className="seguimiento-field">
                  <label>Peso (kg)</label>
                  <div style={{ padding: "0.75rem", background: "#f9f9f9", borderRadius: "10px", border: "1px solid #e0e0e0" }}>
                    {modalVer.peso || "No registrado"}
                  </div>
                </div>
                <div className="seguimiento-field">
                  <label>Talla (cm)</label>
                  <div style={{ padding: "0.75rem", background: "#f9f9f9", borderRadius: "10px", border: "1px solid #e0e0e0" }}>
                    {modalVer.talla || "No registrado"}
                  </div>
                </div>
              </div>
              <div className="seguimiento-grid-2" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "15px", marginTop: "15px" }}>
                <div className="seguimiento-field">
                  <label className="label">Intolerancias</label>
                  <div className="control">
                    <textarea
                      className="textarea"
                      value={modalVer.intolerancia}
                      onChange={(e) => handleCambioEdicion('intolerancia', e.target.value)}
                      placeholder="Ej: lactosa, gluten..."
                      rows={2}
                    />
                  </div>
                </div>
                <div className="seguimiento-field">
                  <label className="label">Alergias</label>
                  <div className="control">
                    <textarea
                      className="textarea"
                      value={modalVer.alergias}
                      onChange={(e) => handleCambioEdicion('alergias', e.target.value)}
                      placeholder="Ej: penicilina, polen..."
                      rows={2}
                    />
                  </div>
                </div>
              </div>
            </section>

            {/* Síntomas */}
            {modalVer.sintomas && (
              <section className="seguimiento-section">
                <h3>Síntomas</h3>
                <div style={{ padding: "0.75rem", background: "#f9f9f9", borderRadius: "10px", border: "1px solid #e0e0e0" }}>
                  {modalVer.sintomas}
                </div>
              </section>
            )}

            {/* Vacunas */}
            {modalVer.vacunas && (
              <section className="seguimiento-section">
                <h3>Vacunas</h3>
                <div style={{ padding: "0.75rem", background: "#f9f9f9", borderRadius: "10px", border: "1px solid #e0e0e0" }}>
                  {modalVer.vacunas}
                </div>
              </section>
            )}

            {/* Tratamiento */}
            {modalVer.medicacion && (
              <section className="seguimiento-section">
                <h3>Tratamiento</h3>
                <div style={{ padding: "0.75rem", background: "#f9f9f9", borderRadius: "10px", border: "1px solid #e0e0e0" }}>
                  {modalVer.medicacion}
                </div>
              </section>
            )}

            {/* Estudios */}
            {modalVer.estudios && (
              <section className="seguimiento-section">
                <h3>Estudios</h3>
                <div style={{ padding: "0.75rem", background: "#f9f9f9", borderRadius: "10px", border: "1px solid #e0e0e0" }}>
                  {modalVer.estudios}
                </div>
              </section>
            )}

            {/* Observaciones */}
            {modalVer.observaciones && (
              <section className="seguimiento-section">
                <h3>Observaciones</h3>
                <div style={{ padding: "0.75rem", background: "#f9f9f9", borderRadius: "10px", border: "1px solid #e0e0e0", minHeight: "60px" }}>
                  {modalVer.observaciones}
                </div>
              </section>
            )}

            <footer className="seguimiento-actions">
              <button 
                className="seguimiento-button seguimiento-button--danger"
                onClick={() => setModalVer(null)}
              >
                Cerrar
              </button>
            </footer>
          </div>
        </div>
      )}

      {/* MODAL EDITAR */}
      {/* Modal de Editar Control */}
      {modalEditar && (
        <div className="modal is-active">
          <div className="modal-background" onClick={() => setModalEditar(null)}></div>
          <div className="modal-card" style={{ maxWidth: "900px", maxHeight: "90vh" }}>
            <header className="modal-card-head">
              <p className="modal-card-title">Editar Control</p>
              <button className="delete" aria-label="close" onClick={() => setModalEditar(null)}></button>
            </header>
            <section className="modal-card-body" style={{ maxHeight: "calc(90vh - 150px)", overflowY: "auto" }}>
              <div style={{ marginBottom: "20px" }}>
                <p style={{ fontSize: "14px", color: "#333" }}><strong>Fecha del control:</strong> {modalEditar.fechaHora}</p>
              </div>

              {/* Datos Antropométricos */}
              <div style={{ marginBottom: "25px" }}>
                <h4 style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "10px", color: "#00bfa5" }}>Datos Antropométricos</h4>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "15px", marginBottom: "15px" }}>
                  <div className="field">
                    <label className="label">Peso (kg)</label>
                    <div className="control">
                      <input
                        className="input"
                        type="number"
                        step="0.1"
                        value={datosEdicion.peso}
                        onChange={(e) => handleCambioEdicion('peso', e.target.value)}
                        placeholder="Ej: 70.5"
                      />
                    </div>
                  </div>

                  <div className="field">
                    <label className="label">Talla (cm)</label>
                    <div className="control">
                      <input
                        className="input"
                        type="number"
                        step="0.1"
                        value={datosEdicion.talla}
                        onChange={(e) => handleCambioEdicion('talla', e.target.value)}
                        placeholder="Ej: 175"
                      />
                    </div>
                  </div>
                </div>

                <div className="field" style={{ marginBottom: "15px" }}>
                  <label className="label">Intolerancias</label>
                  <div className="control">
                    <textarea
                      className="textarea"
                      value={datosEdicion.intolerancias}
                      onChange={(e) => handleCambioEdicion('intolerancias', e.target.value)}
                      placeholder="Ej: lactosa, gluten..."
                      rows={2}
                    />
                  </div>
                </div>

                <div className="field">
                  <label className="label">Alergias</label>
                  <div className="control">
                    <textarea
                      className="textarea"
                      value={datosEdicion.alergias}
                      onChange={(e) => handleCambioEdicion('alergias', e.target.value)}
                      placeholder="Ej: penicilina, polen..."
                      rows={2}
                    />
                  </div>
                </div>
              </div>

              {/* Síntomas */}
              {(() => {
                console.log('[DEBUG] Render modalEditar:', modalEditar);
                console.log('[DEBUG] listaSintomas:', listaSintomas);
                console.log('[DEBUG] datosEdicion.sintomas:', datosEdicion.sintomas);
                if (listaSintomas.length === 0) {
                  return <div style={{color:'red',fontWeight:'bold'}}>[DEBUG] No hay síntomas para mostrar</div>;
                }
                return (
                  <div style={{ marginBottom: "25px", border: '2px dashed orange', padding: 8 }}>
                    <h4 style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "10px", color: "#00bfa5" }}>Síntomas</h4>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))", gap: "15px" }}>
                      {listaSintomas.map(sintoma => (
                        <div key={sintoma.IdSintoma} style={{border:'1px solid #ccc',padding:4}}>
                          <span style={{fontSize:'11px',color:'#888'}}>[{sintoma.IdSintoma}]</span>
                          <RenderField 
                            field={sintoma} 
                            value={datosEdicion.sintomas[sintoma.IdSintoma]} 
                            onChange={(id, val) => handleCambioDinamico('sintomas', id, val)}
                          />
                          <div style={{fontSize:'11px',color:'#009688',marginTop:2}}>
                            Valor actual: <b>{formatearValorActual(datosEdicion.sintomas[sintoma.IdSintoma])}</b>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })()}

              {/* Vacunas */}
              {(() => {
                console.log('[DEBUG] listaVacunas:', listaVacunas);
                console.log('[DEBUG] datosEdicion.vacunas:', datosEdicion.vacunas);
                if (listaVacunas.length === 0) {
                  return <div style={{color:'red',fontWeight:'bold'}}>[DEBUG] No hay vacunas para mostrar</div>;
                }
                return (
                  <div style={{ marginBottom: "25px", border: '2px dashed orange', padding: 8 }}>
                    <h4 style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "10px", color: "#00bfa5" }}>Vacunas</h4>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))", gap: "15px" }}>
                      {listaVacunas.map(vacuna => (
                        <div key={vacuna.IdSintoma} style={{border:'1px solid #ccc',padding:4}}>
                          <span style={{fontSize:'11px',color:'#888'}}>[{vacuna.IdSintoma}]</span>
                          <RenderField 
                            field={vacuna} 
                            value={datosEdicion.vacunas[vacuna.IdSintoma]} 
                            onChange={(id, val) => handleCambioDinamico('vacunas', id, val)}
                          />
                          <div style={{fontSize:'11px',color:'#009688',marginTop:2}}>
                            Valor actual: <b>{formatearValorActual(datosEdicion.vacunas[vacuna.IdSintoma])}</b>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })()}

              {/* Tratamiento */}
              {(() => {
                console.log('[DEBUG] listaMedicaciones:', listaMedicaciones);
                console.log('[DEBUG] datosEdicion.medicaciones:', datosEdicion.medicaciones);
                if (listaMedicaciones.length === 0) {
                  return <div style={{color:'red',fontWeight:'bold'}}>[DEBUG] No hay medicaciones para mostrar</div>;
                }
                return (
                  <div style={{ marginBottom: "25px", border: '2px dashed orange', padding: 8 }}>
                    <h4 style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "10px", color: "#00bfa5" }}>Tratamiento</h4>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))", gap: "15px" }}>
                      {listaMedicaciones.map(medicacion => (
                        <div key={medicacion.IdSintoma} style={{border:'1px solid #ccc',padding:4}}>
                          <span style={{fontSize:'11px',color:'#888'}}>[{medicacion.IdSintoma}]</span>
                          <RenderField 
                            field={medicacion} 
                            value={datosEdicion.medicaciones[medicacion.IdSintoma]} 
                            onChange={(id, val) => handleCambioDinamico('medicaciones', id, val)}
                          />
                          <div style={{fontSize:'11px',color:'#009688',marginTop:2}}>
                            Valor actual: <b>{formatearValorActual(datosEdicion.medicaciones[medicacion.IdSintoma])}</b>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })()}

              {/* Estudios */}
              {(() => {
                console.log('[DEBUG] listaEstudios:', listaEstudios);
                console.log('[DEBUG] datosEdicion.estudios:', datosEdicion.estudios);
                if (listaEstudios.length === 0) {
                  return <div style={{color:'red',fontWeight:'bold'}}>[DEBUG] No hay estudios para mostrar</div>;
                }
                return (
                  <div style={{ marginBottom: "25px", border: '2px dashed orange', padding: 8 }}>
                    <h4 style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "10px", color: "#00bfa5" }}>Estudios</h4>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))", gap: "15px" }}>
                      {listaEstudios.map(estudio => (
                        <div key={estudio.IdSintoma} style={{border:'1px solid #ccc',padding:4}}>
                          <span style={{fontSize:'11px',color:'#888'}}>[{estudio.IdSintoma}]</span>
                          <RenderField 
                            field={estudio} 
                            value={datosEdicion.estudios[estudio.IdSintoma]} 
                            onChange={(id, val) => handleCambioDinamico('estudios', id, val)}
                          />
                          <div style={{fontSize:'11px',color:'#009688',marginTop:2}}>
                            Valor actual: <b>{formatearValorActual(datosEdicion.estudios[estudio.IdSintoma])}</b>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })()}

              {/* Observaciones */}
              <div style={{ marginBottom: "15px" }}>
                <h4 style={{ fontSize: "16px", fontWeight: "bold", marginBottom: "10px", color: "#00bfa5" }}>Observaciones</h4>
                <div className="field">
                  <div className="control">
                    <textarea
                      className="textarea"
                      value={datosEdicion.observaciones}
                      onChange={(e) => handleCambioEdicion('observaciones', e.target.value)}
                      placeholder="Observaciones generales del control..."
                      rows={4}
                    />
                  </div>
                </div>
              </div>
            </section>
            <footer className="modal-card-foot">
              <button className="button is-success" onClick={guardarEdicion}>Guardar Cambios</button>
              <button className="button" onClick={() => setModalEditar(null)}>Cancelar</button>
            </footer>
          </div>
        </div>
      )}

      {/* Modal de Comorbilidades */}
      {modalComorbilidades && (
        <div className="modal is-active">
          <div className="modal-background" onClick={() => setModalComorbilidades(false)}></div>
          <div className="modal-card" style={{ maxWidth: "600px" }}>
            <header className="modal-card-head">
              <p className="modal-card-title">Editar Comorbilidades</p>
              <button className="delete" aria-label="close" onClick={() => setModalComorbilidades(false)}></button>
            </header>
            <section className="modal-card-body">
              <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                {todasComorbilidades.filter(c => c.estado === 1).map(comorbilidad => (
                  <label key={comorbilidad.IdComorbilidad} style={{ display: "block", padding: "8px", cursor: "pointer", borderBottom: "1px solid #eee" }}>
                    <input
                      type="checkbox"
                      checked={comorbilidadesSeleccionadas.includes(comorbilidad.IdComorbilidad)}
                      onChange={() => toggleComorbilidad(comorbilidad.IdComorbilidad)}
                      style={{ marginRight: "10px" }}
                    />
                    {comorbilidad.Nombre}
                    {comorbilidad.Descripcion && <span style={{ color: "#666", fontSize: "12px", display: "block", marginLeft: "24px" }}>{comorbilidad.Descripcion}</span>}
                  </label>
                ))}
              </div>
            </section>
            <footer className="modal-card-foot">
              <button className="button is-success" onClick={guardarComorbilidades}>Guardar</button>
              <button className="button" onClick={() => setModalComorbilidades(false)}>Cancelar</button>
            </footer>
          </div>
        </div>
      )}

      {/* Modal de Atributos */}
      {modalAtributos && (
        <div className="modal is-active">
          <div className="modal-background" onClick={() => setModalAtributos(false)}></div>
          <div className="modal-card" style={{ maxWidth: "600px" }}>
            <header className="modal-card-head">
              <p className="modal-card-title">Editar Atributos Personales</p>
              <button className="delete" aria-label="close" onClick={() => setModalAtributos(false)}></button>
            </header>
            <section className="modal-card-body">
              <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                {todosAtributos.length === 0 ? (
                  <p style={{ textAlign: "center", color: "#999", padding: "20px" }}>No hay atributos disponibles para esta patología</p>
                ) : (
                  todosAtributos.map(atributo => (
                    <label key={atributo.IdAtributo} style={{ display: "block", padding: "8px", cursor: "pointer", borderBottom: "1px solid #eee" }}>
                      <input
                        type="checkbox"
                        checked={atributosSeleccionados.includes(atributo.IdAtributo)}
                        onChange={() => toggleAtributo(atributo.IdAtributo)}
                        style={{ marginRight: "10px" }}
                      />
                      {atributo.NombreAtributo || atributo.Nombre}
                      {atributo.Descripcion && <span style={{ color: "#666", fontSize: "12px", display: "block", marginLeft: "24px" }}>{atributo.Descripcion}</span>}
                    </label>
                  ))
                )}
              </div>
            </section>
            <footer className="modal-card-foot">
              <button className="button is-success" onClick={guardarAtributos}>Guardar</button>
              <button className="button" onClick={() => setModalAtributos(false)}>Cancelar</button>
            </footer>
          </div>
        </div>
      )}
    </div>
  );
}

// ESTILOS - RESTAURADOS A LA VERSIÓN ORIGINAL
const styles = {
  container: {
    padding: "20px",
    fontFamily: "Arial, sans-serif",
    backgroundColor: "#f5f5f5",
    minHeight: "100vh"
  },
  
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "50vh"
  },
  
  loadingSpinner: {
    width: "50px",
    height: "50px",
    border: "5px solid #f3f3f3",
    borderTop: "5px solid #00bfa5",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
    marginBottom: "20px"
  },
  
  cabeceraContainer: {
    backgroundColor: "#fff",
    padding: "15px",
    borderRadius: "8px",
    marginBottom: "20px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
  },
  
  datosLinea: {
    marginBottom: "3px",
    lineHeight: "1.5",
    fontSize: "14px"
  },
  
  dato: {
    color: "#555",
    marginRight: "12px"
  },
  
  btnCabeceraPeque: {
    backgroundColor: "#00bfa5",
    color: "white",
    border: "none",
    padding: "4px 8px",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "12px"
  },
  
  btnVolver: {
    backgroundColor: "#757575",
    color: "white",
    border: "none",
    padding: "8px 12px",
    borderRadius: "4px",
    cursor: "pointer"
  },
  
  btnControlesAnteriores: {
    backgroundColor: "#00bfa5",
    color: "white",
    border: "none",
    padding: "8px 12px",
    borderRadius: "4px",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "14px"
  },
  
  btnNuevoControl: {
    backgroundColor: "#00bfa5",
    color: "white",
    border: "none",
    padding: "8px 16px",
    borderRadius: "4px",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "14px"
  },
  
  tablaContainer: {
    backgroundColor: "#fff",
    borderRadius: "8px",
    padding: "15px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    overflowX: "auto"
  },
  
  tabla: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "13px",
    minWidth: "1200px"
  },
  
  th: {
    backgroundColor: "#e0e0e0",
    padding: "10px",
    border: "1px solid #ccc",
    textAlign: "left",
    fontWeight: "bold",
    whiteSpace: "nowrap"
  },
  
  td: {
    padding: "10px",
    border: "1px solid #eee",
    whiteSpace: "nowrap"
  },
  
  tdAcciones: {
    padding: "10px",
    border: "1px solid #eee",
    whiteSpace: "nowrap"
  },
  
  btnIcono: {
    background: "none",
    border: "none",
    cursor: "pointer",
    fontSize: "16px",
    color: "#00bfa5",
    padding: "0 5px"
  },
  
  // Modal carrusel estilos
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000
  },
  
  modalCarrusel: {
    backgroundColor: "white",
    borderRadius: "8px",
    padding: "20px",
    maxWidth: "700px",
    width: "90%"
  },
  
  modalTituloGrande: {
    textAlign: "center",
    margin: "0 0 20px 0",
    color: "#00bfa5",
    fontSize: "18px",
    fontWeight: "bold"
  },
  
  selectorTabla: {
    display: "flex",
    justifyContent: "center",
    gap: "10px",
    marginBottom: "20px"
  },
  
  btnTablaActiva: {
    backgroundColor: "#00bfa5",
    color: "white",
    border: "none",
    padding: "8px 16px",
    borderRadius: "20px",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "13px"
  },
  
  btnTablaInactiva: {
    backgroundColor: "#e0e0e0",
    color: "#666",
    border: "none",
    padding: "8px 16px",
    borderRadius: "20px",
    cursor: "pointer",
    fontSize: "13px"
  },
  
  carruselContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "15px",
    margin: "20px 0"
  },
  
  btnFlecha: {
    backgroundColor: "#00bfa5",
    color: "white",
    border: "none",
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    cursor: "pointer",
    fontSize: "18px",
    flexShrink: 0
  },
  
  carruselContenido: {
    flex: 1,
    textAlign: "center"
  },
  
  carruselItem: {
    padding: "20px",
    backgroundColor: "#f9f9f9",
    borderRadius: "8px"
  },
  
  detallesItem: {
    textAlign: "left",
    marginTop: "15px"
  },
  
  contador: {
    textAlign: "center",
    fontSize: "14px",
    color: "#666",
    marginBottom: "20px"
  },
  
  modalBotonesGrandes: {
    display: "flex",
    justifyContent: "center"
  },
  
  btnCerrarGrande: {
    backgroundColor: "#757575",
    color: "white",
    border: "none",
    padding: "8px 16px",
    borderRadius: "4px",
    cursor: "pointer"
  },
  
  // Modal general
  modal: {
    backgroundColor: "white",
    borderRadius: "8px",
    padding: "20px",
    maxWidth: "500px",
    width: "90%"
  },
  
  modalTitulo: {
    margin: "0 0 20px 0",
    color: "#333"
  },
  
  modalContenido: {
    marginBottom: "20px"
  },
  
  modalFila: {
    display: "flex",
    justifyContent: "space-between",
    padding: "8px 0",
    borderBottom: "1px solid #eee"
  },
  
  modalEtiqueta: {
    fontWeight: "bold"
  },
  
  modalValor: {
    textAlign: "right"
  },
  
  modalBotones: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px"
  },
  
  btnCerrar: {
    backgroundColor: "#757575",
    color: "white",
    border: "none",
    padding: "8px 16px",
    borderRadius: "4px",
    cursor: "pointer"
  },
  
  btnCancelar: {
    backgroundColor: "#757575",
    color: "white",
    border: "none",
    padding: "8px 16px",
    borderRadius: "4px",
    cursor: "pointer"
  },
  
  btnGuardar: {
    backgroundColor: "#4CAF50",
    color: "white",
    border: "none",
    padding: "8px 16px",
    borderRadius: "4px",
    cursor: "pointer"
  }
};

// Agregar animación de spinner
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;
  document.head.appendChild(style);
}
